import { render, staticRenderFns } from "./BeforeIcon.vue?vue&type=template&id=d66d6c2c&"
import script from "./BeforeIcon.vue?vue&type=script&lang=js&"
export * from "./BeforeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports